import React, { Fragment } from 'react';
import classnames from 'classnames';

import MemoryCommentsItem from './CommentsItem';

import type { Comment } from '../../types/comment';

interface MemoryCommentsListProps {
  comments: Comment[];
  postComment: (params: { content: string; parent_comment_id?: number }) => void;
  updateComment: (params: { commentId: number; content: string }) => void;
  deleteComment: (commentId: number) => void;
  isPosting: boolean;
  isUpdating: boolean;
  level?: number;
  readOnly?: boolean;
}

const MemoryCommentsList: React.FC<MemoryCommentsListProps> = ({
  comments,
  postComment,
  updateComment,
  deleteComment,
  isPosting,
  isUpdating,
  level = 0,
  readOnly = false,
}) => {
  return (
    <div className={classnames('memory-comments-list wa-stack', { 'first-level': level === 0 })}>
      {comments.map((comment) => (
        <Fragment key={comment.id}>
          <MemoryCommentsItem
            handlePostComment={postComment}
            comment={comment}
            handleUpdateComment={updateComment}
            handleDeleteComment={deleteComment}
            isPending={isPosting || isUpdating}
            readOnly={readOnly}
          />
          {(comment.replies && comment.replies.length > 0) && (
            <MemoryCommentsList
              key={comment.id}
              comments={comment.replies}
              postComment={postComment}
              updateComment={updateComment}
              deleteComment={deleteComment}
              isPosting={isPosting}
              isUpdating={isUpdating}
              level={level + 1}
              readOnly={readOnly}
            />
          )}
        </Fragment>
      ))}
    </div>
  );
}

export default MemoryCommentsList;
